import { render, staticRenderFns } from "./icon-logo-name.vue?vue&type=template&id=6d640c9c&"
import script from "./icon-logo-name.vue?vue&type=script&lang=js&"
export * from "./icon-logo-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports